import api from './api';

const brandingService = {
    // Get public branding (no auth)
    getPublicBranding: async () => {
        try {
            return await api.get('/branding');
        } catch (error) {
            console.error('Failed to fetch branding:', error);
            return { success: false, data: {} };
        }
    },

    // Update branding (Admin)
    updateBranding: async (settings) => {
        try {
            return await api.put('/branding', settings);
        } catch (error) {
            throw error;
        }
    },

    // Upload file
    uploadFile: async (file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            return await api.upload('/branding/upload', formData);
        } catch (error) {
            throw error;
        }
    }
};

export default brandingService;
